module.exports = __webpack_public_path__ + "img/code-css-xs.c47d4f5b.webp";